import { render, staticRenderFns } from "./IconHeartCrack.vue?vue&type=template&id=67bd0faa&"
import script from "./IconHeartCrack.vue?vue&type=script&lang=js&"
export * from "./IconHeartCrack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports